// Note: COVID 14 day rate color code are from CDC.gov
export const COVID_14_DAY_RATE_CATEGORIES = [
    {
        gte: 0.0, lt: 5.0,
        // 'color' is used in county report table
        color:'rgba(76, 131, 12, 0.5)',
        // colroHex is used in graphics
        colorHex: '#4c830c',
        title: 'Lowest Risk'
    },
    {
        gte: 5.0, lt: 20.0,
        color:'rgba(132, 188, 74, 0.5)',
        colorHex: '#84bc4a',
        title: 'Lower Risk'
    },
    {
        gte: 20.0, lt: 50.0,
        color:'rgba(255, 233, 125, 0.5)',
        colorHex: '#ffe97d',
        title: 'Moderate Risk'
    },
    {
        gte: 50.0, lt: 200.0,
        color:'rgba(255, 173, 66, 0.5)',
        colorHex: '#ffad42',
        title: 'Higher Risk'
    },
    {
        gte: 200.0, lt: null,
        color:'rgba(175, 68, 72, 0.5)',
        colorHex: '#af4448',
        title: 'Highest Risk'
    }
]

export const AQI_CATEGORIES = [
    {
        gte: 0, lt: 9.1,
        // 'color' is used in county report table
        color: 'rgba(46, 204, 112, 0.5)',
        // colroHex is used in graphics
        colorHex: '#2ECC70',
        title: 'Good'
    },
    {
        gte: 9.1, lt: 35.5,
        color: 'rgba(241, 196, 14, 0.5)',
        colorHex: '#F1C40E',
        title: 'Mod'
    },
    {
        gte: 35.5, lt: 55.5,
        color: 'rgba(230, 126, 34, 0.5)',
        colorHex: '#E67E22',
        title: 'USG'
    },
    {
        gte: 55.5, lt: 125.5,
        color: 'rgba(231, 76, 60, 0.5)',
        colorHex: '#E74C3C',
        title: 'Unh'
    },
    {
        gte: 125.5, lt: 225.5,
        color: 'rgba(209, 157, 215, 0.5)',
        colorHex: '#D19DD7',
        title: 'V Un'
    },
    {
        gte: 225.5, lt:  null,
        color: 'rgba(140, 58, 58, 0.5)',
        colorHex: '#8C3A3A',
        title: 'Haz'
    }
  // TODO: add two more groups give cut-points 350.5 and 500.5?
];


// copied from https://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb#5624139
function hexToRgb(hex, options) {
    options = options || {};
    let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    if (result) {
        let rgb = {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        };
        return `rgba(${rgb.r},${rgb.g},${rgb.b}, ${options.opacity || 0.5})`
    }
    return  null
}


/*
 * Red color scheme used in table and other places
 */
//export const RED_GRADIENT_HEX = //colorbrewer.Reds[9]
export const RED_GRADIENT_HEX = [
  '#ffffff','#ffe5e5','#ffcccc','#ffb2b2','#ff9999','#ff7f7f',
   '#ff6666','#ff4c4c','#ff3333','#ff1919','#ff0000'
]

/*
 * generateCategories produces color gradient structured like AQI_CATEGORIES
 *
 * options:
 *   - reverse: reverse colors provided
 *   - opacity: used for rgb color
 */
export function generateCategories(maxCutoff, colorGradient, options) {
  options = options || {};
  let interval = maxCutoff / (colorGradient.length - 1);
  return colorGradient.map((e, i) => {
    let gte = i * interval;
    let lt = (i < colorGradient.length - 1) ? (gte + interval) : null;
    let colorHex = (options.reverse) ? (colorGradient[colorGradient.length - 1 - i]) : (colorGradient[i])
    return {
      gte: gte,
      lt: lt,
      colorHex: colorHex,
      color: hexToRgb(colorHex, options)
    }
  })
}

/*
 * getCategory works with any list of categories structured like AQI_CATEGORIES
 */
export function getCategory(categories, value) {
    for (var i in categories) {
        if (! categories[i].lt || value < categories[i].lt) {
            return {idx: i, category: categories[i]}
        }
    }
}
